import React from 'react';
import { useOfflineToggle } from './useOfflineToggle';
import './OfflineToggle.css';
const OfflineToggle = ({ className = '', scale = 1 }) => {
  const { offline, isBrowserOnline, isManualOffline, toggle } = useOfflineToggle();

  const title = !isBrowserOnline
    ? 'No internet connection — working offline'
    : isManualOffline
      ? 'Working offline — click to go back online'
      : 'Online — click to work offline';

  const selectOnline = () => { if (offline && isBrowserOnline) toggle(); };
  const selectOffline = () => { if (!offline) toggle(); };

  return (
    <div
      className={`offline-seg ${offline ? 'is-offline' : 'is-online'} ${!isBrowserOnline ? 'is-disabled' : ''} ${className}`}
      role="group"
      aria-label="Work online or offline"
      title={title}
      style={scale !== 1 ? { transform: `scale(${scale})`, transformOrigin: 'center' } : undefined}
    >
      <button
        type="button"
        className="offline-seg-option offline-seg-online"
        onClick={selectOnline}
        disabled={!isBrowserOnline}
        aria-pressed={!offline}
      >
        <span className="offline-seg-dot" />
        Online
      </button>
      <button
        type="button"
        className="offline-seg-option offline-seg-offline"
        onClick={selectOffline}
        disabled={!isBrowserOnline}
        aria-pressed={offline}
      >
        <span className="offline-seg-dot" />
        Offline
      </button>
    </div>
  );
};

export default OfflineToggle;
